import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { API_PATHS } from '../config/api-paths';
import {
  EdDestinationList,
  EdPrescoringResults,
  EdPrescoringResultsApi,
  InviteToSdfResponse,
  ProductionDestination,
  SendToProductionResponse,
} from '../tokens/ed-prescoring-results.token';

/**
 * REST implementation of the E-D Stage-0d results / distribution / promotion API
 * (BRS §1A.0e, EM-808/809/810).
 *
 *   GET  /services/embedded/api/v1/ed/prospects/results
 *   GET  /services/embedded/api/v1/ed/prospects/destinations/{destination}
 *   POST /services/embedded/api/v1/ed/prospects/{prospectId}/send-to-production
 *   POST /services/embedded/api/v1/ed/prospects/{prospectId}/invite-to-sdf
 *
 * The calling E-D is resolved server-side from the JWT (Rule 22 — no id in the URL).
 * REST-only (Rules 07/10). Bound to ED_PRESCORING_RESULTS in mock-data.providers.ts.
 */
@Injectable({ providedIn: 'root' })
export class EdPrescoringResultsRestService implements EdPrescoringResultsApi {
  private readonly http = inject(HttpClient);
  private readonly base = `${API_PATHS.EMBEDDED_API_BASE}/v1/ed/prospects`;

  getResults(): Observable<EdPrescoringResults> {
    return this.http.get<EdPrescoringResults>(`${this.base}/results`);
  }

  getDestination(destination: ProductionDestination): Observable<EdDestinationList> {
    return this.http.get<EdDestinationList>(`${this.base}/destinations/${destination}`);
  }

  sendToProduction(prospectId: number, destination: ProductionDestination): Observable<SendToProductionResponse> {
    return this.http.post<SendToProductionResponse>(
      `${this.base}/${prospectId}/send-to-production`,
      { destination },
    );
  }

  inviteToSdf(prospectId: number): Observable<InviteToSdfResponse> {
    return this.http.post<InviteToSdfResponse>(`${this.base}/${prospectId}/invite-to-sdf`, {});
  }
}
